export function unmask(val) {
  return val.replace(/[$, ]+/g, '');
}

export function numberUnmask(val) {
  return (val.match(/\d+/g) || []).join('');
}
